import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "text-center"
}
const _hoisted_2 = {
  key: 3,
  class: "text-center"
}
const _hoisted_3 = {
  key: 4,
  class: "text-center"
}
const _hoisted_4 = {
  key: 5,
  class: "text-center"
}
const _hoisted_5 = {
  key: 0,
  class: "text-center"
}
const _hoisted_6 = {
  key: 11,
  class: "text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_cheap = _resolveComponent("cheap")!

  return (_ctx.column.key === 'invoiceNumber')
    ? (_openBlock(), _createBlock(_component_router_link, {
        key: 0,
        class: "text-blue-500 text-center",
        to: `/invoice/${_ctx.row.id}`,
        target: "_blank"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.row.invoiceNumber), 1)
        ]),
        _: 1
      }, 8, ["to"]))
    : (_ctx.column.key === 'stopsCount')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.row[_ctx.column.key] || 0), 1))
      : (_ctx.column.key === 'problems')
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.row.problems, (pb, i) => {
            return (_openBlock(), _createBlock(_component_cheap, {
              key: `pb-${i}`,
              class: "w-max small mb-2"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(pb), 1)
              ]),
              _: 2
            }, 1024))
          }), 128))
        : (_ctx.column.key === 'weight')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.row[_ctx.column.key] || 0), 1))
          : (_ctx.column.key === 'volumeWeight')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.row[_ctx.column.key] || 0), 1))
            : (_ctx.column.key === 'places')
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.row[_ctx.column.key] || 0), 1))
              : (_ctx.column.key === 'statusId')
                ? (_openBlock(), _createElementBlock("i", {
                    key: 6,
                    class: _normalizeClass(_ctx.getCheckOrTimesIcon(_ctx.row.statusId === 1))
                  }, null, 2))
                : (_ctx.column.key === 'hasProblems')
                  ? (_openBlock(), _createElementBlock("i", {
                      key: 7,
                      class: _normalizeClass(_ctx.getCheckOrTimesIcon(_ctx.row.hasProblems))
                    }, null, 2))
                  : (_ctx.column.key === 'timer')
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 8,
                        class: _normalizeClass(_ctx.getTimerClass)
                      }, _toDisplayString(_ctx.row.timer), 3))
                    : (_ctx.column.key === 'shipmentType')
                      ? (_openBlock(), _createElementBlock("i", {
                          key: 9,
                          class: _normalizeClass(_ctx.getShipmentIcon(_ctx.row.shipmentType))
                        }, null, 2))
                      : (_ctx.column.key === 'courier')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 10 }, [
                            (_ctx.row.courier)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.row.courier.fullName), 1))
                              : _createCommentVNode("", true)
                          ], 64))
                        : (_ctx.column.key === 'waitList' && _ctx.row.waitList)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.row[_ctx.column.key].name || '-'), 1))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 12 }, [
                              _createTextVNode(_toDisplayString(_ctx.row[_ctx.column.key] || '-'), 1)
                            ], 64))
}